import {ErrorHandler, Injectable, Injector, NgZone} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ApplicationError} from '../modules/shared/model/application-error';
import * as StackTrace from 'stacktrace-js';
import {ErrorLogService} from '../modules/shared/service/error-log.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private zone: NgZone;
  private errorLogService: ErrorLogService;

  constructor(private injector: Injector) {
    setTimeout(() => {
      this.zone = injector.get(NgZone);
      this.errorLogService = injector.get(ErrorLogService);
    });
  }

  handleError(error) {
    if (error instanceof HttpErrorResponse) {
    } else {
      StackTrace.fromError(error).then(stackFrames => {
        this.errorLogService.sendError(new ApplicationError(error.message, stackFrames, new Date().toISOString()));
      });
      throw error;
    }
  }
}
